module.exports = __webpack_public_path__ + "static/media/barcodeUnselected.4206b16a.svg";